import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "../../lib/api";
import { StatusSelect, PayBadge, fmtDate } from "./shared";
import { ItemOptions } from "../../pages/Cart";

const FULFIL = ["new", "in_progress", "ready", "completed"];

export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [filter, setFilter] = useState("paid");
  useEffect(() => { api.get("/admin/orders").then((r) => setOrders(r.data)); }, []);

  const update = async (id, status) => {
    try {
      const { data } = await api.patch(`/admin/orders/${id}`, { status });
      setOrders((os) => os.map((o) => (o.id === id ? data : o)));
      toast.success("Order updated");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!orders) return <p className="text-white/60">Loading orders...</p>;
  const shown = orders.filter((o) => filter === "all" || o.payment_status === filter);

  return (
    <div data-testid="admin-orders">
      <div className="mb-4 flex flex-wrap gap-2">
        {["all", "paid", "pending", "failed", "refunded"].map((f) => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`orders-filter-${f}`}
            className={`rounded-full px-4 py-1.5 text-sm font-bold capitalize ${filter === f ? "bg-[var(--pink)]" : "bg-white/5 text-white/70"}`}>{f}</button>
        ))}
      </div>
      {!shown.length && <p className="panel p-8 text-center text-white/60" data-testid="orders-empty">No orders yet.</p>}
      <div className="space-y-4">
        {shown.map((o) => (
          <div key={o.id} className="panel p-5" data-testid={`order-row-${o.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <p className="font-display text-xl">{o.order_number}</p>
                <PayBadge status={o.payment_status} testid={`order-payment-status-${o.id}`} />
              </div>
              <StatusSelect value={o.fulfillment_status} options={FULFIL} onChange={(v) => update(o.id, v)} testid={`order-fulfillment-select-${o.id}`} />
            </div>
            <div className="mt-4 grid gap-4 text-sm md:grid-cols-3">
              <div className="text-white/75">
                <p className="font-bold text-white">{o.customer.name}</p>
                <p>{o.customer.email}</p>
                <p>{o.customer.phone}</p>
                <p className="text-white/50">{fmtDate(o.created_at)}</p>
                {o.address && (
                  <p className="mt-2 text-white/75" data-testid={`order-address-${o.id}`}>
                    {o.address.line1}{o.address.line2 ? `, ${o.address.line2}` : ""}<br />{o.address.city}, {o.address.state} {o.address.zip}
                  </p>
                )}
              </div>
              <ul className="space-y-1 text-white/75">
                {o.items.map((i, idx) => <li key={idx}>{i.quantity} × {i.name}<ItemOptions item={i} /></li>)}
              </ul>
              <div>
                <p className="font-display text-2xl text-[var(--pink)]">{money(o.amount_total ?? o.subtotal)}</p>
                <p className="mt-1 text-xs font-bold text-white/60" data-testid={`order-shipping-${o.id}`}>
                  {o.shipping ? `Mail: ${o.shipping.label} · ${money(o.shipping.amount_cents / 100)}` : o.address ? "Local delivery" : ""}
                </p>
                {o.customer.note && <p className="mt-1 rounded-xl bg-white/5 p-2 text-white/70">Note: {o.customer.note}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
